module.exports = __webpack_public_path__ + "img/slideVerify_13.2e5a5fa8.png";